(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-renewal"]) return;
  try {
    
(() => {
  if (window.corekaraHeaderInitialized) return;
  window.corekaraHeaderInitialized = true;
  let controller;

  class HeaderController {
    constructor(sticky) {
      this.sticky = sticky;
      this.root = sticky.closest('.shopify-section');
      if (!this.root) return;
      this.abort = new AbortController();
      this.media = window.matchMedia('(min-width: 992px)');
      this.desktop = this.media.matches;
      this.drawer = this.root.querySelector('#drawer');
      this.drawerToggle = this.root.querySelector('[data-header-drawer-toggle]');
      this.desktopNav = this.root.querySelector('.hdrFixed--pc .hdrBottom.pcOnly');
      this.lastScroll = window.scrollY;
      this.lockUntil = 0;
      this.active = null;
      this.frame = null;
      this.inertNodes = [];
      this.on(this.root, 'click', event => this.click(event));
      this.on(document, 'keydown', event => this.keydown(event));
      this.on(document, 'focusin', event => this.focusin(event));
      this.on(document, 'corekara:close-menu', () => this.close(false));
      this.on(window, 'resize', () => this.resize());
      this.on(window, 'scroll', () => this.scroll(), { passive: true });
      this.on(this.media, 'change', () => this.resize());
      if (window.visualViewport) this.on(window.visualViewport, 'resize', () => this.measure());
      this.observer = new ResizeObserver(() => this.measure());
      this.observer.observe(sticky);
      this.root.querySelectorAll('[data-header-category-toggle]').forEach(button => {
        const icon = button.querySelector('img');
        if (icon) {
          icon.classList.add('header-category-open-icon');
          icon.alt = '';
          const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
          svg.setAttribute('viewBox', '0 0 24 24');
          svg.setAttribute('aria-hidden', 'true');
          svg.classList.add('header-category-close-icon');
          const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
          path.setAttribute('d', 'M5 5L19 19M19 5L5 19');
          path.setAttribute('stroke', 'currentColor');
          path.setAttribute('stroke-width', '2');
          svg.append(path);
          icon.after(svg);
        }
      });
      this.measure();
    }

    on(target, name, handler, options = {}) {
      target.addEventListener(name, handler, { ...options, signal: this.abort.signal });
    }

    click(event) {
      if (event.target.closest('#cartDrawerTrigger')) {
        event.preventDefault();
        return;
      }
      const toggle = event.target.closest('[data-header-drawer-toggle], [data-header-category-toggle]');
      if (toggle) {
        event.preventDefault();
        if (this.active?.trigger === toggle) {
          this.close();
          return;
        }
        const kind = toggle.hasAttribute('data-header-drawer-toggle') ? 'drawer' : 'category';
        if (kind === 'drawer' && this.desktop) return;
        const panel = document.getElementById(toggle.getAttribute('aria-controls'));
        if (!panel || !this.root.contains(panel)) return;
        this.open(kind, toggle, panel);
        return;
      }
      if (event.target.closest('[data-header-drawer-close], #headerDrawerOverlay, [data-header-category-overlay]')) {
        event.preventDefault();
        this.close();
        return;
      }
      const accordion = event.target.closest('[data-header-accordion]');
      if (accordion) {
        const panel = document.getElementById(accordion.getAttribute('aria-controls'));
        if (!panel) return;
        const expanded = accordion.getAttribute('aria-expanded') !== 'true';
        accordion.setAttribute('aria-expanded', String(expanded));
        panel.hidden = !expanded;
        return;
      }
      if (this.active?.panel.contains(event.target) && event.target.closest('a[href]')) this.close(false);
    }

    open(kind, trigger, panel) {
      this.close(false);
      this.desktopNav?.classList.remove('is-hidden');
      const overlay = kind === 'drawer'
        ? this.root.querySelector('#headerDrawerOverlay')
        : trigger.closest('.hdrFixed--pc, .header-sp-block--sp-gnav')?.querySelector('[data-header-category-overlay]');
      const text = trigger.querySelector('.bottomNav__text');
      this.active = { kind, trigger, panel, overlay, text, label: text?.textContent };
      panel.hidden = false;
      panel.inert = false;
      panel.classList.add('open');
      panel.setAttribute('aria-hidden', 'false');
      trigger.classList.add('open');
      trigger.setAttribute('aria-expanded', 'true');
      if (kind === 'drawer') trigger.setAttribute('aria-label', trigger.dataset.closeLabel);
      if (text) text.textContent = trigger.dataset.closeLabel;
      if (overlay) overlay.hidden = false;
      document.body.classList.add('header-renewal-menu-open');
      this.measure();
      if (kind === 'drawer') {
        this.inertBackground();
        const first = this.focusable(panel)[0] || panel;
        first.focus({ preventScroll: true });
      }
    }

    close(restoreFocus = true) {
      if (!this.active) return;
      const { kind, trigger, panel, overlay, text, label } = this.active;
      this.active = null;
      this.inertNodes.forEach(node => { node.inert = false; });
      this.inertNodes = [];
      if (restoreFocus && trigger.isConnected && trigger.getClientRects().length) trigger.focus({ preventScroll: true });
      else if (panel.contains(document.activeElement)) document.activeElement.blur();
      panel.classList.remove('open');
      panel.hidden = true;
      panel.inert = true;
      panel.setAttribute('aria-hidden', 'true');
      trigger.classList.remove('open');
      trigger.setAttribute('aria-expanded', 'false');
      if (kind === 'drawer') trigger.setAttribute('aria-label', trigger.dataset.openLabel);
      if (text) text.textContent = label;
      if (overlay) overlay.hidden = true;
      document.body.classList.remove('header-renewal-menu-open');
      this.lastScroll = window.scrollY;
    }

    inertBackground() {
      const { panel, trigger, overlay } = this.active;
      const protect = [panel, trigger, overlay].filter(Boolean);
      const visit = node => {
        for (const child of node.children) {
          if (protect.includes(child) || /^(SCRIPT|STYLE|LINK)$/.test(child.tagName)) continue;
          if (protect.some(item => child.contains(item))) visit(child);
          else if (!child.inert) {
            child.inert = true;
            this.inertNodes.push(child);
          }
        }
      };
      visit(document.body);
    }

    focusable(panel) {
      return [...panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex="0"]')]
        .filter(node => !node.closest('[inert], [hidden]') && node.getClientRects().length);
    }

    keydown(event) {
      if (event.key === ' ' && event.target.id === 'cartDrawerTrigger') {
        event.preventDefault();
        event.target.click();
        return;
      }
      if (!this.active) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        this.close();
        return;
      }
      if (event.key !== 'Tab' || this.active.kind !== 'drawer') return;
      const nodes = [this.active.trigger, ...this.focusable(this.active.panel)];
      const index = nodes.indexOf(document.activeElement);
      if (event.shiftKey && index <= 0) {
        event.preventDefault();
        nodes.at(-1)?.focus();
      } else if (!event.shiftKey && (index === nodes.length - 1 || index === -1)) {
        event.preventDefault();
        nodes[0]?.focus();
      }
    }

    focusin(event) {
      if (!this.active || this.active.panel.contains(event.target) || this.active.trigger.contains(event.target)) return;
      if (this.active.kind === 'category') this.close(false);
      else (this.focusable(this.active.panel)[0] || this.active.panel).focus({ preventScroll: true });
    }

    measure() {
      this.root.style.setProperty('--renewal-sticky-height', `${this.sticky.offsetHeight}px`);
      if (!this.active) return;
      const viewportBottom = window.visualViewport
        ? window.visualViewport.offsetTop + window.visualViewport.height
        : window.innerHeight;
      const top = this.active.panel.getBoundingClientRect().top;
      this.active.panel.style.setProperty('--header-panel-max-height', `${Math.max(80, viewportBottom - Math.max(0, top) - 12)}px`);
      if (this.active.kind === 'drawer') {
        this.root.style.setProperty('--header-overlay-top', `${Math.max(0, this.sticky.getBoundingClientRect().bottom)}px`);
      }
    }

    resize() {
      if (this.desktop !== this.media.matches) {
        this.close(false);
        this.desktop = this.media.matches;
        this.desktopNav?.classList.remove('is-hidden');
        this.lastScroll = window.scrollY;
      }
      this.measure();
    }

    scroll() {
      if (this.frame !== null) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.measure();
        const current = Math.max(0, window.scrollY);
        if (!this.desktop || this.sticky.dataset.autoHide !== 'true' || this.active || this.desktopNav?.contains(document.activeElement)) {
          this.lastScroll = current;
          return;
        }
        if (current < 70) {
          this.desktopNav?.classList.remove('is-hidden');
          this.lastScroll = current;
          return;
        }
        if (performance.now() < this.lockUntil) {
          this.lastScroll = current;
          return;
        }
        if (Math.abs(current - this.lastScroll) <= 10) return;
        const hide = current > this.lastScroll;
        if (this.desktopNav && this.desktopNav.classList.contains('is-hidden') !== hide) {
          this.desktopNav.classList.toggle('is-hidden', hide);
          this.lockUntil = performance.now() + 300;
        }
        this.lastScroll = current;
      });
    }

    destroy() {
      this.close(false);
      this.abort.abort();
      this.observer.disconnect();
      if (this.frame !== null) cancelAnimationFrame(this.frame);
      this.root.querySelectorAll('.header-category-close-icon').forEach(icon => icon.remove());
    }
  }

  function initialize() {
    controller?.destroy();
    const sticky = document.querySelector('[data-header-renewal]');
    controller = sticky ? new HeaderController(sticky) : null;
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', event => {
    if (event.target.querySelector('[data-header-renewal]')) initialize();
  });
  document.addEventListener('shopify:section:unload', event => {
    if (controller?.root === event.target) {
      controller.destroy();
      controller = null;
    }
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
